import View from './view';
import {VisuallyImpairedGroup} from '../group';
import React from 'react';
import {ReduxWrapperProps} from './model';

export const VisuallyImpairedSwitch = View;

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const ReduxVisuallyImpairedSwitch = ({input: {onChange, value}, meta, label, ...props}: ReduxWrapperProps) => (
  <VisuallyImpairedGroup label={label}>
    <VisuallyImpairedSwitch {...props} value={value} onChange={onChange} />
  </VisuallyImpairedGroup>
);
